<template>
  <vx-card >
  <h5 class="mb-3">School Profile</h5>
  <div class="vx-row" >
    <div class="vx-col sm:w-1/3 w-full mb-2">
      <vs-input class="w-full" label-placeholder="School Name" v-model="School.name" />
    </div>
    <div class="vx-col sm:w-1/3 w-full mb-2">
      <vs-input class="w-full" label-placeholder="Phone" @input="acceptNumber" v-model="School.phone" />
    </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
      <vs-input class="w-full" label-placeholder="Website" v-model="School.website" />
    </div>
  </div>
    <div class="vx-row">
    <div class="vx-col sm:w-1/2 w-full mb-2">
      <vs-input class="w-full" label-placeholder="Address 1" v-model="School.address1" />
    </div>
    <div class="vx-col sm:w-1/2 w-full mb-2">
       <vs-input class="w-full" label-placeholder="Address 2" v-model="School.address2" />
    </div>
  </div>
    <div class="vx-row">
    <div class="vx-col sm:w-1/3 w-full mb-2">
      <vs-input class="w-full" label-placeholder="City" v-model="School.city" />
    </div>
    <div class="vx-col sm:w-1/3 w-full mb-2">
      <vs-input class="w-full" label-placeholder="State" v-model="School.state" />
    </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
      <vs-input class="w-full" label-placeholder="Zip" v-model="School.zip" />
    </div>
  </div>
      <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
      <vs-input class="w-full" label-placeholder="Enrollment Capacity" v-model="School.capacity" />
    </div>   
        <div class="vx-col sm:w-1/3 w-full mb-2 mt-5">
        <v-select   placeholder="Select Time Zone"  :closeOnSelect="true" v-model="School.timezone"  :options="timezones"  />
      <!-- <vs-input class="w-full" label-placeholder="Time Zone" v-model="School.timezone" /> -->
    </div>
        <div class="vx-col sm:w-1/3 w-full mb-2 mt-5">
      <!-- <vs-input class="w-full" placeholder="Select Country" v-model="School.country" /> -->
      <v-select   placeholder="Select Country"  :closeOnSelect="true" v-model="School.country"  :options="countries"  />
    </div>
  </div>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-button class="mr-3 mb-2" @click.native="SchoolSubmit">Submit</vs-button>
    </div>
  </div>
    </vx-card>
         
</template>

<script>
import {ADD_SCHOOL, GET_SCHOOL_PROFILE} from '@/graphql'
import vSelect from 'vue-select'

export default {
  components: {
    'v-select': vSelect
  },
  data () {
    return {
      School:{
        name:'',
        phone:'',
        website:'',
        city:'',
        state:'',
        zip:'',
        country:'',
        timezone:'',
        capacity:'',
        address1:'',
        address2:''
      },
      timezones : [
        'Eastern Standard Time (EST)',
        'Central Standard Time (CST)',
        'Pacific Standard Time (PST)',
        'Mountain Standard Time (MST)',
        'Alaska Standard Time (AKST)',
        'Hawaii Standard Time (AHST)'
      ],
      countries : ['United States']
    }
  },
  methods: {
    acceptNumber () {
      const x = this.School.phone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      this.School.phone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    },
    SchoolSubmit () {
      this.$apollo
        .mutate({
          mutation: ADD_SCHOOL,
          variables: {
            school: this.School
          }
        })
        .then(response => {
          if (response) {
            this.StatusSuccess()
          }
        }).catch(error => {
          console.log(error)
        })

    },
    StatusSuccess () {
      this.$vs.notify({
        title: 'School Profile',
        text: 'Saved Successfully!',
        color: 'success',
        position: 'top-right'
      })
    }
  },
  beforeCreate () {
    this.$apollo
      .query({
        query: GET_SCHOOL_PROFILE
      })
      .then(response => {
        if (response.data.getSchoolProfile.school_name !== null) {
          this.School.name = response.data.getSchoolProfile.school_name
        }
        if (response.data.getSchoolProfile.school_phone !== null) {
          this.School.phone = response.data.getSchoolProfile.school_phone
        }
        if (response.data.getSchoolProfile.school_website !== null) {
          this.School.website = response.data.getSchoolProfile.school_website
        }
        if (response.data.getSchoolProfile.school_city !== null) {
          this.School.city = response.data.getSchoolProfile.school_city
        }
        if (response.data.getSchoolProfile.school_state !== null) {
          this.School.state = response.data.getSchoolProfile.school_state
        }
        if (response.data.getSchoolProfile.school_zip !== null) {
          this.School.zip = response.data.getSchoolProfile.school_zip
        }
        if (response.data.getSchoolProfile.school_country !== null) {
          this.School.country = response.data.getSchoolProfile.school_country
        }
        if (response.data.getSchoolProfile.school_timezone !== null) {
          this.School.timezone = response.data.getSchoolProfile.school_timezone
        }
        if (response.data.getSchoolProfile.school_capacity !== null) {
          this.School.capacity = response.data.getSchoolProfile.school_capacity
        }
        if (response.data.getSchoolProfile.school_address1 !== null) {
          this.School.address1 = response.data.getSchoolProfile.school_address1
        }
        if (response.data.getSchoolProfile.school_address2 !== null) {
          this.School.address2 = response.data.getSchoolProfile.school_address2
        }
       

      })
      .catch(error => {
        console.log(error)
      })
  },
  created () {

  }
}
</script>

<style scoped>

</style>
